export * from './authenticator';
export * from './isNAASupportAvailable';

export const acquireTokenTimeoutInMilliseconds = 15000;
